import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Briciole from "../shared/briciole/Briciole";
import PackageMainData from "./packageMainData/PackageMainData";
import PackageGallery from "./packageGallery/PackageGallery";
import PackageTabs from "./packageTabs/PackageTabs";

import PackageConfigurationUnita from "./packageConfigurationUnita/PackageConfigurationUnita";
import PackageSlideshowOtherProducts from "./packageSlideshowOtherProducts/PackageSlideshowOtherProducts";
import PackageSlideshowAccessories from "./packageSlideshowAccessories/PackageSlideshowAccessories";

const PackageDetail = () => {
  const pageContent = useSelector((state) => state.currentPage.pageContent);
  const promotion = useSelector((state) => state.promotion);

  // local state
  const [fixedPriceId, setFixedPriceId] = useState(0);

  useEffect(() => {
    return () => {
      console.log("PackageDetail");
    };
  }, [fixedPriceId]);

  // controllo che siano stati recuperati i dati del prodotto (altrimenti vuol dire che sto ancora recuperando i dati)
  if (!pageContent.isFetched || pageContent.isFetched === undefined) {
    return <div></div>;
  }

  const onUpdateMainData = (productFixedPriceId) => {
    // aggiorno prezzo fisso (se presente)
    setFixedPriceId(productFixedPriceId);
  };

  // controllo tipologia prodotto in base all'unità di misura e ad eventuali flags attivi
  let productTypeFields = "";

  // prodotto venduto per quantità
  productTypeFields = (
    <PackageConfigurationUnita updateMainData={onUpdateMainData} />
  );

  // stile diverso per la scheda outlet (senza padding)
  const detailStyle = pageContent.isProntaConsegna
    ? "px-8"
    : "px-8 py-10 mt-0 sm:mt-4 xl:mt-0";

  return (
    <div className="col-start-1 lg:col-start-15 4xl:col-start-16 col-end-61 3xl:col-end-59 4xl:col-end-57 pb-12">
      <Briciole />
      <div className="grid grid-cols-60 mt-6">
        <div className="col-start-4 sm:col-start-1 col-end-58 sm:col-end-61 xl:col-end-35">
          <PackageMainData prezzoFissoIndex={fixedPriceId} />
          <PackageGallery promotion={promotion} />
          <div className="grid grid-cols-60">
            <div className="col-span-60 mt-3 mb-12 block xl:hidden">
              <PackageTabs />
            </div>
          </div>
        </div>
        <div
          className={`col-start-1 xl:col-start-37 col-end-61 bg-ribola-gallery-gray ${detailStyle}`}
        >
          {productTypeFields}
        </div>
      </div>
      <div className="grid grid-cols-60">
        <div className="col-span-60 mt-10 mb-12 hidden xl:block">
          <PackageTabs />
        </div>
      </div>
      <div className="grid grid-cols-60">
        <div className="col-span-60">
          <PackageSlideshowOtherProducts />
        </div>
      </div>
      <div className="grid grid-cols-60">
        <div className="col-span-60">
          <PackageSlideshowAccessories />
        </div>
      </div>
    </div>
  );
};

export default PackageDetail;
